export const SMALL_FINAL = 'Small Final';
export const STAGE_TYPE_PLAYOFF = 'PLAYOFF';
export const resultTypeForDisplaying = 'TOTALSCORE';
export const FINAL = 'Final';
export const FINAL_RESULT = 'FINALRESULT';
